export default {
    to: "/dashboard/waas/",
    order: 3,
    icon: "mdi-star-four-points",
    title: "Loyalty Points",
    disabled: false,
    value: 0,
    sublinks: [
        {
            to: "/dashboard/waas/loyalty-points/redeem",
            order: 3,
            icon: "mdi-autorenew",
            title: "Redeem Points",
            disabled: false,
            value: 0,
        },
        {
            to: "/dashboard/waas/loyalty-points/top-up",
            order: 3,
            icon: "mdi-archive-arrow-up",
            title: "Top Up Beneficiary",
            disabled: false,
            value: 0,
        },
        {
            to: "/dashboard/waas/loyalty-points/share-to-beneficiary",
            order: 3,
            icon: "mdi-share-variant-outline",
            title: "Share Points",
            disabled: false,
            value: 0,
        },
        {
            to: "/dashboard/waas/loyalty-points/transfer-to-merchant",
            order: 3,
            icon: "mdi-transfer",
            title: "Transfer Points",
            disabled: false,
            value: 0,
        },
    ]
}
